import { useQuery } from '@apollo/client';
import { useAuth } from 'oidc-react';
import { GET_CHECKLIST_EDITOR_PERMISSION } from './checklistTemplate.graphql';

export const useCanEditChecklists = () => {
  const auth = useAuth();
  const { data } = useQuery(GET_CHECKLIST_EDITOR_PERMISSION, { variables: { userId: auth?.userData?.profile.sub } });
  return data?.users?.[0]?.canEditChecklists ?? false;
};
